module.exports = __webpack_public_path__ + "img/P150T_weapon_81.0c04cc7a.png";